import {SETTINGS, MANAGEMENT, APPOINTMENTS, ACTIVATION, CLINICIANS, VOUCHER, ANALYTICS, STAFF_ACTIVITY} from './svgIcons';
import StorageService from "services/StorageService";
import { SUPER_ADMIN } from "./roles";
import { USER } from "./storageConstants";

/**
 * The menu for whoever is signed in NOW. Worked out on every render of the sidebar - it used to be a
 * module-level constant, evaluated once when the bundle loaded. Logging in does not reload the page,
 * so a super admin who signed in did not see Statistics until a manual reload, and the next person
 * to sign in on the same tab kept the previous user's menu.
 */
export function getSidebarLinks() {
    const isUserSuperAdmin = new StorageService().getValueByKey(USER)?.role === SUPER_ADMIN;

    const links = [
        {to: "/appointments", label: "Appointments", icon: APPOINTMENTS},
        {to: "/patients-management", label: "Patients management", icon: MANAGEMENT},
        {to: "/activation-code", label: "Activation code", icon: ACTIVATION},
        {to: "/voucher", label: "Voucher code", icon: VOUCHER},
        // Super admins only (the route sends everyone else back to Appointments): only super admins
        // create clinicians or edit their records.
        ...(isUserSuperAdmin ? [{to: "/clinicians-management", label: "Clinicians management", icon: CLINICIANS}] : []),
        // { to: "/user-analytics", label: "User analytics", icon: ANALYTICS },
        {to: "/settings", label: "Settings", icon: SETTINGS}
    ];

    if (isUserSuperAdmin) {
        links.push({to: "/statistics", label: "Statistics", icon: ANALYTICS});
        // Super admins only (the route sends everyone else back to Appointments; the API refuses them).
        links.push({to: "/staff-activity", label: "Staff activity", icon: STAFF_ACTIVITY});
    }

    return links;
}
